// Lib
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import createEditorTypeToggledTool from './createEditorTypeToggledComponent';
import UnindentTaskToolContainer from '../taskTools/UnindentTaskToolContainer';

// Utils
import { getCurrentlyEditingId } from '../../../../../element/selection/currentlyEditingSelector';
import { unIndentTask } from '../../../../../element/taskList/taskListActions';

// Selectors
import { isUnindentTaskToolDisabledSelector } from './selectors/taskListToolSelector';

// Hooks
import { useActiveTiptapEditorCallback } from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Components
import RichTextTool from '../richContentTools/RichTextTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const TiptapUnindentTaskListTool = (props: ToolbarToolProps): ReactElement => {
    const currentlyEditingId = useSelector(getCurrentlyEditingId);

    const isToolDisabled = useSelector(isUnindentTaskToolDisabledSelector);

    const dispatch = useDispatch();

    const handleClick = useActiveTiptapEditorCallback((activeEditor, event: PointerEvent) => {
        if (!activeEditor) return;

        const textContent = activeEditor.getJSON();

        return dispatch(
            unIndentTask({
                elementId: currentlyEditingId,
                textContent,
            }),
        );
    });

    return (
        <RichTextTool
            onClick={handleClick}
            disabled={isToolDisabled}
            iconName={props.iconName || 'toolbar-unindent'}
            {...props}
        />
    );
};

export default createEditorTypeToggledTool(TiptapUnindentTaskListTool, UnindentTaskToolContainer);
